import { isClientMessage } from './utils'

/**
 * Assign analysed intent to the latest user message in state.messages Array
 * @param {Object} state
 * @param {Object} intentAnalysed
 */
export function assignIntentAnalysedToUserMessage(state, intentAnalysed) {
  if (!state.messages || state.messages.length === 0) {
    return
  }

  // Let's not reverse the state itself !!
  const reversedMessages = Array.from(state.messages)
  reversedMessages.reverse()

  // Find the last client message
  const findMessageIndex = reversedMessages.findIndex(
    message =>
      isClientMessage(message.origin) &&
      (!Object.prototype.hasOwnProperty.call(message, 'intentAnalysed') || message.intentAnalysed === null)
  )

  // the intentAnalysed should be null and the message should be the last message sent by the user
  if (
    findMessageIndex !== 0 || // Should be last sent message
    !reversedMessages[findMessageIndex] ||
    (Object.prototype.hasOwnProperty.call(reversedMessages[findMessageIndex], 'intentAnalysed') &&
      reversedMessages[findMessageIndex].intentAnalysed !== null)
  ) {
    return
  }

  // It was reversed index, so correct is messages.length -1

  // Set the data.intentAnalysed to the user message with index found
  state.messages[state.messages.length - 1] = {
    ...state.messages[state.messages.length - 1],
    intentAnalysed: intentAnalysed
  }
}
